import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIsMobile } from 'helpers/hooks';
import { isNullish } from 'helpers/objects';
import styles from './styles.module.scss';

const NUM_COLUMNS = 12;

function Column({ lg, sm, centered, endAligned, styles: customStyles, children }) {
  const isMobile = useIsMobile(); // TODO: do this without the JS hook?

  const calculateWidth = () => {
    if (isMobile && !isNullish(sm)) {
      return 100 * (sm / NUM_COLUMNS);
    }
    return 100 * (lg / NUM_COLUMNS);
  };

  const width = calculateWidth();

  return (
    <div
      className={classnames([
        styles.column,
        {
          [styles.centered]: centered,
          [styles.endAligned]: endAligned,
          [styles.hidden]: width <= 0
        },
        ...customStyles
      ])}
      style={{ width: `${width}%` }}>
      {children}
    </div>
  );
}

Column.propTypes = {
  lg: PropTypes.number,
  sm: PropTypes.number,
  centered: PropTypes.bool,
  endAligned: PropTypes.bool,
  styles: PropTypes.array,
  children: PropTypes.any
};

Column.defaultProps = {
  lg: 12,
  sm: null,
  centered: false,
  endAligned: false,
  styles: [],
  children: null
};

export default Column;
